import axios from 'axios';
import config from '../config/apiConfig';
import { getToken } from '../utils/jwtUtils';

// Create Axios instance
const apiClient = axios.create({
    baseURL: config.API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request Interceptor: Attach Authorization Token
apiClient.interceptors.request.use(
    (request) => {
        // const token = localStorage.getItem('token');
        const token = getToken();
        if (token) {
            request.headers.Authorization = `Bearer ${token}`;
        }
        return request;
    },
    (error) => Promise.reject(error)
);

// Response Interceptor: Handle Global Errors
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            // Handle 401 Unauthorized (e.g., Token Expired)
            if (error.response.status === 401) {
                console.warn('Token expired or unauthorized. Redirecting to login.');
                // Optional: Redirect to Sign-In Page
                window.location.href = '/signin';
            }
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Error setting up request:', error.message);
        }
        return Promise.reject(error);
    }
);

export default apiClient;
